__turbopack_context__.v({
  "container": "NoiIZG_container",
  "leftAccessory": "NoiIZG_leftAccessory",
});
